import { useObserver } from 'mobx-react-lite';
import { Instance } from 'mobx-state-tree';
import React from 'react';
import { Product } from '../models/Product';
import { ProductVariationSelectProps } from '../types/ProductVariationSelectProps';
import { TypeProduct } from '../types/TypeProduct';
import { parseSortString, sortProducts } from '../utils/productSorts';
import { sortByFn } from '../utils/sortByProperty';

const ProductVariationSelect: React.FC<ProductVariationSelectProps> = (
  props,
) => {
  const { data } = props;
  const variations: Instance<typeof Product>[] | null = data?.variations;
  let options: TypeProduct[] = [];
  options = variations?.map((x) => {
    return x as TypeProduct;
  }) as TypeProduct[];

  if (props.variationsort) {
    options = sortProducts(options, parseSortString(props.variationsort ?? ''));
  } else {
    options.sort(sortByFn((f) => f.variationTypeDescription));
  }

  const selectedVariation = (data?.selectedVariation ?? data) as TypeProduct;
  const setSelectedVariation = (id: number | null) => {
    data.setSelectedVariation(id);
  };

  const onVariationChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const variationProductId = parseInt(event.target.value);
    if (data.id === variationProductId) {
      setSelectedVariation(data.id);
    } else {
      const filteredVariation = options
        ?.filter((v) => v.id === variationProductId)
        ?.pop();
      if (filteredVariation) {
        setSelectedVariation(filteredVariation.id);
      }
    }
  };

  return useObserver(() =>
    data && variations && variations.length ? (
      <select
        className={`variation-select ${props.className ?? ''}`}
        onChange={onVariationChange}
      >
        <option
          key={data.id}
          value={data.id}
          selected={data.id === selectedVariation.id}
        >
          {data.variationTypeDescription ||
            (data.isWine ? 'Bottle' : data.name)}
        </option>
        {options?.map((v) => (
          <option
            key={v.id}
            value={v.id}
            selected={v.id === selectedVariation.id}
          >
            {v.variationTypeDescription ?? v.name}
          </option>
        ))}
      </select>
    ) : (
      <></>
    ),
  );
};

export default ProductVariationSelect;
